import React from "react";
import { reportError } from "../../helpers/reportError";

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * Catches render errors in a subtree so a single failing panel degrades to an
 * inline message instead of unmounting the whole app (which renders a blank
 * page, as happened when a facet payload was null).
 */
class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error) {
    reportError("react.render", error, { component: "ErrorBoundary" });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="bg-red-50 text-red-700 border border-red-200 rounded p-4 text-sm">
          <p className="font-medium mb-1">
            Ocorreu um erro ao mostrar esta secção.
          </p>
          <p className="text-red-600 mb-3">{this.state.error.message}</p>
          <button
            className="button is-small"
            onClick={() => this.setState({ error: null })}
          >
            Tentar novamente
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
